import React from 'react'
import { motion } from 'framer-motion/dist/framer-motion'

const Waves = React.forwardRef((props, ref) => {
    const drawWave = (color) => {
        return {
            hidden: () => { 
                return {
                    pathLength: 0,
                    fill: '#FFFFFF',
                    fillOpacity: 0,
                    stroke: '#FFFFFF',
                    opacity: 0
                }
            },
            visible: (i) => {
                let stroke = color
                const strokeDelay = i * 0.5
                const fillDelay = strokeDelay + 0.25
                const transition = {
                    pathLength: { delay: strokeDelay, duration: 2, ease: "easeInOut" },
                    opacity: { delay: strokeDelay, duration: 0.1 },
                    fillOpacity: { delay: fillDelay, duration: 1.5, ease: "easeInOut"},
                    fill: { delay: fillDelay, duration: 1.5, ease: "easeInOut"},
                }
                return {
                    pathLength: 1.1,
                    fill: color,
                    fillOpacity: 1,
                    stroke,
                    opacity: 1,
                    pathOffset: 0,
                    transition,
                }
            },
        }
    }
    
    return (
        <motion.svg
            ref={ref}
            className="mga-contact-section__bg"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1366 424"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.1 }}
            style={{ 
                fillRule: "evenodd", 
                clipRule: "evenodd", 
                strokeLinejoin: "round", 
                strokeMiterlimit: 2,
                strokeWidth: 0.2
            }}
        >
            <defs><clipPath id="a"><path fill="none" d="M0 0h1365.996v335.912H0z"/></clipPath></defs>
            <motion.path
                d="M1366 328.388a4595.496 4595.496 0 0 0-97.438-41.336 4662.416 4662.416 0 0 0-99.512-39.526 4656.594 4656.594 0 0 0-122.408-45.019 4555.88 4555.88 0 0 0-121.879-40.957 4468.54 4468.54 0 0 0-121.123-36.913 4370.44 4370.44 0 0 0-120.147-32.892 4232.037 4232.037 0 0 0-118.944-28.887 4061.13 4061.13 0 0 0-117.519-24.9 3881.57 3881.57 0 0 0-115.867-20.944A3698.75 3698.75 0 0 0 217.168 0H1366v328.388z"
                stroke="#e23b00"
                fill="#FFFFFF"
                variants={drawWave("#e23b00")}
                initial="hidden"
                animate="visible"
                custom={0}
                style={{
                    fillRule: "nonzero",
                }}
            />
            <g transform="translate(0 88.453)" clipPath="url(#a)">
                <motion.path
                    d="M113.987 101.357Q55.328 113.585 0 126.182v205.97c575.276-42.872 1025.393-110.866 1366-25.856V24.593C1033.4-20.451 640.983-8.471 113.987 101.357"
                    stroke="#ef7d10"
                    fill="#FFFFFF"
                    variants={drawWave("#ef7d10")}
                    initial="hidden"
                    animate="visible"
                    custom={2}
                    style={{
                        fillRule: "nonzero",
                    }}
                />
            </g>
            <motion.path
                d="M1365.995 327.391a4583.635 4583.635 0 0 0-97.437-41.337 4643.181 4643.181 0 0 0-99.513-39.523 4632.548 4632.548 0 0 0-122.427-45.03 4566.427 4566.427 0 0 0-121.884-40.961 4470.195 4470.195 0 0 0-121.118-36.914 4372.139 4372.139 0 0 0-88.7-24.641c246.663-19.96 458.83-12.985 651.079 13.042z"
                stroke="#505257"
                fill="#ef7d10"
                variants={drawWave("#505257")}
                initial="hidden"
                animate="visible"
                custom={2}
                style={{
                    fillRule: "nonzero",
                }}
            />
        </motion.svg>
    )
})

export default React.memo(Waves)